import { render } from "./latest-hero-banner.vue?vue&type=template&id=c8096d94"
import script from "./latest-hero-banner.vue?vue&type=script&lang=js"
export * from "./latest-hero-banner.vue?vue&type=script&lang=js"

import "./latest-hero-banner.vue?vue&type=style&index=0&id=c8096d94&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__